import React from "react";
import { useHistory } from "react-router-dom"; // Correct for v5
import homeStyle from "./HomeStyle.module.css";
import { TopHeader } from "../Header/TopHeader";
import { ButtonHover } from "../ReuseableComp/ButtonHover";
import AllApps from "../Apps/AllApps";
import { RiAddCircleLine, RiSearchLine } from "react-icons/ri";
import { FirstAppHeader } from "../Header/FirstAppHeader";
import BottomActionBtn from "../BottomActionBtn";
import BgAnimation from "../Animation/BgAnimation";

const HomePage = () => {
  const history = useHistory(); // useHistory for v5

  return (
    <div
      style={{ position: "relative", overflow: "hidden", minHeight: "100vh", }}
    >
      {/* <FirstAppHeader /> */}
      {/* <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          pointerEvents: "none", // Prevents animation from blocking clicks
        }}
      >
        <BgAnimation />
      </div> */}
      <div className={homeStyle.homeContainer}>
        <div className={homeStyle.homeContaint}>
          <h1>All Applications</h1>

          <AllApps />
        </div>

        <div
          className={homeStyle.supportTicket}
          onClick={() => history.push("/support")}
        >
          <span>Raise A Support Ticket</span>
        </div>
        {/* <BottomActionBtn
          buttons={[
            {
              text: "Get started",
              onClick: () => console.log("Start clicked"),
            },
            {
              text: "Raise A Support Ticket",
              onClick: () => history.push("/support"),
            },
          ]}
        /> */}
        {/* <div className="actionBtns">
          <ButtonHover text="Get started" />
          <ButtonHover
            text="Raise A Support Ticket"
            onClick={() => {
              history.push("/support"); // v5 way to navigate
            }}
          />
        </div> */}
      </div>
    </div>
  );
};

export default HomePage;
